import { defineComponent as _defineComponent } from 'vue'
import { CurrencyData } from 'ah-api-gateways';
import { computed, reactive, watch, PropType } from 'vue';
import { FieldOptionObj } from 'ah-common-lib/src/form/interfaces';
import { useAhTradesState } from '../..';
import TagMultiSelect from 'ah-common-lib/src/common/components/selects/TagMultiSelect.vue';

interface CurrencyOption extends FieldOptionObj {
  currencyLabel: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyFilterSelect',
  props: {
  title: {
    type: String,
    required: false,
  },
  allowedCurrencies: {
    type: Array as PropType<string[]>,
    required: false,
  },
  maxFulltextLabels: {
    type: Number,
    required: false,
    default: 3,
  },
  placeholder: {
    type: String,
    required: false,
  },
  value: {
    type: Array,
    required: false,
    default: () => [],
  },
  clearable: {
    type: [Boolean, String],
    required: false,
    default: true,
  },
},
  emits: ["update:value"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:value', value: any[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;



const state = reactive<{
  tradeableCurrencies: CurrencyData[];
  options: CurrencyOption[];
}>({
  tradeableCurrencies: [],
  options: [],
});



const tradeState = useAhTradesState();

function loadCurrencies() {
  tradeState.store
    .useSettingsStore()
    .loadTradeableCurrencies()
    .then((currencies) => {
      state.tradeableCurrencies = currencies;
    });
}
loadCurrencies();

const showClear = computed(() => isClearable.value && props.value && props.value.length > 0);

const isClearable = computed(() => props.clearable !== false);

function clearField() {
  emit('update:value', []);
}

function checkOptionFilter(option: CurrencyOption, label: string, search: string) {
  const searchable = `${option.value} ${option.currencyLabel}`;
  return searchable.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1;
}

watch(
  () => [state.tradeableCurrencies, props.allowedCurrencies],
  () => {
    state.options = state.tradeableCurrencies
      .filter((c) => !props.allowedCurrencies || props.allowedCurrencies.includes(c.currency))
      .map((c) => ({ label: c.currency, value: c.currency, currencyLabel: c.name }));
  },
  { immediate: true }
);

return { __sfc: true,props, state, emit, tradeState, loadCurrencies, showClear, isClearable, clearField, checkOptionFilter, TagMultiSelect }
}

})